<div class="row">
    <label class="col-sm-4 col-md-3 text-sm-end" [ngClass]="label_class">{{ row_label }}</label>
    <div class="col-sm-8 col-md-9">
      <ng-content></ng-content>
    </div>
  </div>